var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1409_29697)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.78125C4.91188 0.78125 0.78125 4.91188 0.78125 10C0.78125 15.0881 4.91188 19.2188 10 19.2188C15.0881 19.2188 19.2188 15.0881 19.2188 10C19.2188 4.91188 15.0881 0.78125 10 0.78125ZM10 1.71875C14.5706 1.71875 18.2812 5.42937 18.2812 10C18.2812 14.5706 14.5706 18.2812 10 18.2812C5.42937 18.2812 1.71875 14.5706 1.71875 10C1.71875 5.42937 5.42937 1.71875 10 1.71875Z",
    fill: "#2D2057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99945 2.93945C6.1032 2.93945 2.93945 6.1032 2.93945 9.99945C2.93945 13.8957 6.1032 17.0595 9.99945 17.0595C13.8957 17.0595 17.0595 13.8957 17.0595 9.99945C17.0595 6.1032 13.8957 2.93945 9.99945 2.93945ZM9.99945 3.87695C13.3782 3.87695 16.122 6.6207 16.122 9.99945C16.122 13.3782 13.3782 16.122 9.99945 16.122C6.6207 16.122 3.87695 13.3782 3.87695 9.99945C3.87695 6.6207 6.6207 3.87695 9.99945 3.87695Z",
    fill: "#2D2057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.17 11.2144C11.17 10.9569 11.0794 10.7587 10.8987 10.6187C10.7175 10.4794 10.3913 10.3387 9.91938 10.1969C9.4475 10.055 9.0725 9.89687 8.79375 9.7225C8.26 9.3875 7.99375 8.95 7.99375 8.41125C7.99375 7.93937 8.18563 7.55062 8.57063 7.245C8.955 6.94 9.45437 6.78687 10.0681 6.78687C10.4756 6.78687 10.8394 6.86187 11.1581 7.01187C11.4769 7.1625 11.7275 7.37625 11.91 7.65375C12.0925 7.93062 12.1837 8.23875 12.1837 8.57625H11.17C11.17 8.27062 11.0744 8.03125 10.8825 7.85875C10.6913 7.68562 10.4169 7.59937 10.0606 7.59937C9.72813 7.59937 9.47 7.67 9.28625 7.8125C9.1025 7.95437 9.01062 8.1525 9.01062 8.4075C9.01062 8.62187 9.11 8.80062 9.30812 8.94437C9.50687 9.0875 9.83375 9.22687 10.2894 9.3625C10.745 9.49812 11.1112 9.65187 11.3875 9.825C11.6631 9.9975 11.8656 10.1962 11.9944 10.42C12.1231 10.6437 12.1875 10.9056 12.1875 11.2062C12.1875 11.6937 12.0006 12.0819 11.6262 12.37C11.2525 12.6581 10.745 12.8025 10.1044 12.8025C9.68125 12.8025 9.29188 12.7244 8.93625 12.5675C8.58125 12.4106 8.305 12.1937 8.10812 11.9181C7.91125 11.6419 7.8125 11.32 7.8125 10.9525H8.83C8.83 11.285 8.94 11.5425 9.15937 11.725C9.37937 11.9069 9.69437 11.9981 10.1044 11.9981C10.4581 11.9981 10.7244 11.9269 10.9025 11.7831C11.0813 11.64 11.17 11.45 11.17 11.2144Z",
    fill: "#2D2057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53125 6.25V13.3394C9.53125 13.5981 9.74125 13.8081 10 13.8081C10.2588 13.8081 10.4688 13.5981 10.4688 13.3394V6.25C10.4688 5.99125 10.2588 5.78125 10 5.78125C9.74125 5.78125 9.53125 5.99125 9.53125 6.25Z",
    fill: "#2D2057"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1409_29697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.340b648b0ac3926adc4524b2ae9b8aee.svg";
export { ForwardRef as ReactComponent };